/* eslint-disable */
import { Button } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import moment from "moment";
import Pagination from "../Pagination";
import { GET } from "../../../utils/HttpRequests";

export default function CallLogs() {
  const reactUrl = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    v_mobile_no: "",
    callerMobileNo: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(100);
  const [pageNo, setPageNumber] = useState(1);
  const [detail, setDetail] = useState({});

  const fetchCallLogs = async () => {
    try {
      setLoading(true);
      let url = `${reactUrl}admin/console/calls?pageNo=${pageNo}&pageSize=${pageSize}`;
      Object.keys(formData).forEach((key) => {
        if (formData[key]) {
          url = `${url}&${key}=${formData[key]}`;
        }
      });

      const res = await GET(url);
      setDetail({ ...detail, ...res?.data?.response });
      setLoading(false);
      setPageSize(100);
    } catch (err) {
      setLoading(false);
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchCallLogs();
  }, [pageNo]);

  const onChange = (e) => {
    setError("");
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  let callData;

  // eslint-disable-next-line prefer-const
  callData = loading
    ? null
    : detail.calls.map((call) => (
        <>
          <tr>
            <td>{call.v_mobile_no || "-"}</td>
            <td>{call?.zvr_mobile_no ? call?.zvr_mobile_no : "-"}</td>
            <td>{call?.s_mobile_no ? call?.s_mobile_no : "-"}</td>
            <td>
              <span uib-tooltip="ReceivedAt">
                {call?.received_at
                  ? moment(call?.received_at).format("DD-MM-YYYY, h:mm:ss A")
                  : "-"}
              </span>
            </td>
          </tr>
        </>
      ));
  return (
    <div
      style={{
        display: "flex",
        padding: "1%",
        justifyContent: "space-between",
        flexWrap: "wrap",
        boxShadow: "none",
      }}
    >
      <div>
        <h4 style={{ paddingRight: "2px" }}>Call Logs List</h4>
      </div>
      <div style={{ flexBasis: "100%" }}>
        <form className="form-horizontal">
          <div
            style={{ display: "flex", paddingRight: "10%", margin: "1% 0%" }}
          >
            <div className="inputs-fl-1">
              <input
                type="text"
                name="search"
                className="form-control"
                id="v_mobile_no"
                value={formData.v_mobile_no}
                placeholder="VMN"
                onChange={onChange}
              />
            </div>
            <div className="inputs-fl-1">
              <input
                type="text"
                name="search"
                className="form-control"
                id="callerMobileNo"
                value={formData.callerMobileNo}
                placeholder="Caller Mobile No"
                onChange={onChange}
              />
            </div>
            <div>
              <Button variant="danger" onClick={fetchCallLogs}>
                Search
              </Button>
            </div>
            <div />
          </div>
        </form>
        <>
          <div className="table-responsive bn">
            <table className="table">
              <thead className="thad-dark">
                <tr>
                  <th>Virtual Number</th>
                  <th>User No</th>
                  <th>Caller Mobile No</th>
                  <th>Received At</th>
                </tr>
              </thead>
              <tbody>
                {callData}
                {error && <div style={{ color: "red" }}>{error}</div>}
              </tbody>
            </table>
          </div>
        </>
      </div>
      <Pagination
        currentPage={pageNo}
        lastPage={detail.totalPages + 1}
        totalPages={detail.totalPages + 1}
        setPageNumber={(page) => {
          setPageNumber(page);
        }}
      />
    </div>
  );
}
